export var useOptionIconModifier = function (option) {
    return {
        isSpecialLuggageOverweightOption: !!option.shortDescription.match(/55[\w×]40[\w×]20/gi)
    };
};
